export const SYMBOL = '>=';

export default function func(exp1: string | number | null | undefined, exp2: string | number | null | undefined) {
    if (exp1 === null || exp1 === undefined || exp2 === null || exp2 === undefined) {
        return false;
    }
    return exp1 >= exp2;
}

func.SYMBOL = SYMBOL;
